import type { DemoKey } from './keys';

export const hi: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'ज्यामिति · 3D',
  'panel.figure': 'आकृति',
  'panel.dims': 'आयाम',
  'panel.style': 'रूप',
  'panel.lines': 'विशेष रेखाएँ',
  'style.body': 'पिंड',
  'style.line': 'रेखा',
  'style.cut': 'खंड',
  'style.labels': 'शीर्ष लेबल',
  'group.face': 'फलक विकर्ण / जनक',
  'group.space': 'विकर्ण / अक्ष / माध्यिकाएँ',
  'split.label': 'खंड',
  'btn.animate': 'चलाएँ',
  'btn.reset': 'रीसेट',
  'hint.line1': 'घुमाने के लिए खींचें · ज़ूम के लिए स्क्रॉल',
  'hint.line2': 'चयन के लिए रेखा पर क्लिक करें',
  'fig.cuboid': 'घनाभ',
  'fig.cube': 'घन',
  'fig.triPrism': 'त्रिभुजाकार प्रिज्म',
  'fig.hexPrism': 'षट्भुजाकार प्रिज्म',
  'fig.tetrahedron': 'चतुष्फलक',
  'fig.squarePyramid': 'वर्गाकार पिरामिड',
  'fig.cylinder': 'बेलन',
  'fig.cone': 'शंकु',
  'fig.sphere': 'गोला',
  'fig.frustumPyramid': 'पिरामिड का छिन्नक',
  'fig.frustumCone': 'शंकु का छिन्नक',
  'dim.length': 'लंबाई',
  'dim.width': 'चौड़ाई',
  'dim.height': 'ऊँचाई',
  'dim.side': 'भुजा',
  'dim.radius': 'त्रिज्या',
  'dim.r1': 'निचली त्रिज्या',
  'dim.r2': 'ऊपरी त्रिज्या',
  'dim.sideBase': 'आधार भुजा',
  'dim.sideTop': 'ऊपरी भुजा',
  'info.face': 'फलक',
  'info.center': 'केंद्र से',
  'info.diagonal': 'विकर्ण',
  'info.axial': 'अक्षीय विकर्ण',
  'info.diameter': 'व्यास',
  'info.generator': 'जनक',
  'info.axis': 'अक्ष',
  'info.height': 'ऊँचाई',
  'info.median': 'माध्यिका',
  'info.apothem': 'अपोथेम',
  'info.diameterBase': 'आधार व्यास',
  'info.diameterTop': 'ऊपरी व्यास',
};
